/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Theme_ValueInputs */

const en_us2_search_field_theme_value = /** @type {(inputs: Search_Field_Theme_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light, dark or system`)
};

const pt_br2_search_field_theme_value = /** @type {(inputs: Search_Field_Theme_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro, escuro ou do sistema`)
};

const es_419_search_field_theme_value = /** @type {(inputs: Search_Field_Theme_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro, oscuro o del sistema`)
};

const pt_pt2_search_field_theme_value = /** @type {(inputs: Search_Field_Theme_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro, escuro ou do sistema`)
};

const fr_fr2_search_field_theme_value = /** @type {(inputs: Search_Field_Theme_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clair, sombre ou système`)
};

const de_de2_search_field_theme_value = /** @type {(inputs: Search_Field_Theme_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hell, dunkel oder System`)
};

const it_it2_search_field_theme_value = /** @type {(inputs: Search_Field_Theme_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiaro, scuro o di sistema`)
};

/**
* | output |
* | --- |
* | "Light, dark or system" |
*
* @param {Search_Field_Theme_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_theme_value = /** @type {((inputs?: Search_Field_Theme_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Theme_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_theme_value(inputs)
	if (locale === "es-419") return es_419_search_field_theme_value(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_theme_value(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_theme_value(inputs)
	if (locale === "de-DE") return de_de2_search_field_theme_value(inputs)
	if (locale === "it-IT") return it_it2_search_field_theme_value(inputs)
	return en_us2_search_field_theme_value(inputs)
});
export { search_field_theme_value as "search.field_theme_value" }